<!-- =====================================================================
     LAUDITOR PRODUCT — NEW REVAMPED DESIGN
     ===================================================================== -->
<ng-container *ngIf="product === 'lauditor'">
  <div class="lx-page-container">

    <!-- LEFT HERO PANEL -->
    <div class="lx-left-section">
      <div class="lx-blob lx-blob-1"></div>
      <div class="lx-blob lx-blob-2"></div>
      <div class="lx-bg-dots" aria-hidden="true"></div>

      <div class="lx-hero-content">
        <div class="lx-hero-top">
          <h1 class="lx-hero-title">Your entire legal practice, organized on one secure platform</h1>
          <!-- <div class="lx-hero-divider" aria-hidden="true"></div> -->
          <!-- <p class="lx-hero-subtitle">Manage matters, clients, documents, billing, appointments and more—all in one secure place.</p> -->
        </div>

        <div class="lx-illustration-wrap">
          <!-- <span class="lx-float-icon lx-float-shield" aria-hidden="true"><i class="fa fa-shield"></i></span>
          <span class="lx-float-icon lx-float-doc" aria-hidden="true"><i class="fa fa-file-text"></i></span>
          <span class="lx-float-icon lx-float-cloud" aria-hidden="true"><i class="fa fa-cloud"></i></span> -->
          <img src="/assets/site/images/illustration_bg.png" alt="Lex-Z Digital" class="lx-illustration">
        </div>

        <!-- <div class="lx-feature-row">
          <div class="lx-feature-item">
            <i class="fa fa-shield" aria-hidden="true"></i>
            <span>Bank-grade Security</span>
          </div>
          <div class="lx-feature-item">
            <i class="fa fa-cloud" aria-hidden="true"></i>
            <span>Access Anywhere</span>
          </div>
          <div class="lx-feature-item">
            <i class="fa fa-balance-scale" aria-hidden="true"></i>
            <span>Built for Law Firms</span>
          </div>
        </div> -->
      </div>

      <div class="lx-copyright">Lex-Z Lawyers 2026. All rights reserved.</div>
    </div>

    <!-- RIGHT FORM PANEL -->
    <div class="lx-right-section">
      <div class="lx-form-container">

        <!-- Logo -->
        <div class="lx-login-header">
          <img src="/assets/img/lexi-zlogo2.png" alt="Lex-Z" class="lx-logo">
        </div>

        <!-- Alert message -->
        <label class="lx-alert-msg" *ngIf="msg" [style.color]="msgError ? '#dc2626' : '#16a34a'">
           {{msg}}
        </label>

        <!-- MAIN LOGIN FORM (showLoginForm) -->
        <div *ngIf="showLoginForm">
          <h2 class="lx-form-title">
            <!-- {{ otpSent ? 'Verify OTP' : 'Log in with OTP' }} -->
            {{ usePasswordLogin ? 'Login with Password' : (otpSent ? 'Verify OTP' : 'Login with OTP') }}
          </h2>

          <form [formGroup]="otpForm" (ngSubmit)="onOTPSubmit()">

            <!-- Identifier field (hidden after OTP sent) -->
            <div class="lx-field-wrap" *ngIf="!otpSent">
                <input #identifierInput formControlName="identifier" class="lx-input" id="id_otp_identifier" type="text"
                  [placeholder]="usePasswordLogin ? 'Enter Email or Mobile Number' : 'Email or Mobile Number'" autocomplete="username"
                  (input)="removeLeadingSpace($event)" />

              <!-- <div *ngIf="otpSubmitted && otpF['identifier'].errors" class="lx-error">
                <span *ngIf="otpF.identifier.errors.required">Email or Mobile is required</span>
                <span *ngIf="otpF.identifier.errors.invalidIdentifier">Enter a valid email or 10-digit mobile number</span>
              </div> -->

              <div *ngIf="otpSubmitted && otpF['identifier'].errors" class="lx-error">
                <span *ngIf="otpF.identifier.errors.required">
                  {{ usePasswordLogin ? 'Email is required' : 'Email or Mobile is required' }}
                </span>
              
                <span *ngIf="usePasswordLogin && otpF.identifier.errors.email">
                    {{ usePasswordLogin ? '' : 'Enter a valid email address' }}
                </span>
              
                <span *ngIf="!usePasswordLogin && otpF.identifier.errors.invalidIdentifier">
                   {{ usePasswordLogin ? '' : 'Enter a valid email or 10-digit mobile number' }}
                </span>
              
              </div>

            </div>

            <!-- Password login -->
            <div *ngIf="usePasswordLogin" class="lx-field-wrap lx-password-wrap">
              <input #passwordInput formControlName="password" [type]="showPassword ? 'text' : 'password'" class="lx-input"
                placeholder="Enter Password" />
            
              <!-- Eye Icon -->
              <span class="lx-eye-icon"  [ngClass]="showPassword ? 'eye-slash-pos' : 'eye-pos'" (click)="togglePasswordVisibility()">
                <i [class]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </span>
            
              <div *ngIf="otpSubmitted && otpF['password']?.errors" class="lx-error">
                <span *ngIf="otpF['password'].errors.required">Password is required</span>
              </div>
            </div>

            <!-- OTP sent message -->
            <!-- <div *ngIf="otpSent" class="lx-otp-sent-msg">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#1d4ed8"/><path d="M4.5 8l2.5 2.5 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              OTP sent successfully
            </div> -->

            <!-- OTP boxes (shown after OTP sent) -->
            <div class="lx-otp-section" *ngIf="otpSent && !usePasswordLogin">
              <label class="lx-otp-label">Enter 6-digit OTP</label>
              <div class="lx-otp-boxes">
                <input #otp1 type="text" maxlength="1" inputmode="numeric"
                  class="lx-otp-box"
                  (keyup)="onOtpKeyUp($event, 1, otp2)"
                  (paste)="onOtpPaste($event)"
                  [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"/>
                <input #otp2 type="text" maxlength="1" inputmode="numeric"
                  class="lx-otp-box"
                  (keyup)="onOtpKeyUp($event, 2, otp3)"
                  [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"/>
                <input #otp3 type="text" maxlength="1" inputmode="numeric"
                  class="lx-otp-box"
                  (keyup)="onOtpKeyUp($event, 3, otp4)"
                  [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"/>
                <input #otp4 type="text" maxlength="1" inputmode="numeric"
                  class="lx-otp-box"
                  (keyup)="onOtpKeyUp($event, 4, otp5)"
                  [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"/>
                <input #otp5 type="text" maxlength="1" inputmode="numeric"
                  class="lx-otp-box"
                  (keyup)="onOtpKeyUp($event, 5, otp6)"
                  [(ngModel)]="otpDigits[4]" [ngModelOptions]="{standalone: true}"/>
                <input #otp6 type="text" maxlength="1" inputmode="numeric"
                  class="lx-otp-box"
                  (keyup)="onOtpKeyUp($event, 6, null)"
                  [(ngModel)]="otpDigits[5]" [ngModelOptions]="{standalone: true}"/>
              </div>

              <div *ngIf="otpSubmitted && otpF['otp'].errors" class="lx-error">
                <span *ngIf="otpF['otp'].errors?.required">OTP is required</span>
                <span *ngIf="otpF['otp'].errors?.pattern">OTP must be 6 digits</span>
              </div>

              <!-- Resend -->
              <div class="lx-resend-row">
                <a href="javascript:void(0);"
                  class="lx-resend-link"
                  [class.lx-resend-disabled]="resendDisabled"
                  (click)="resendOTP()">
                  {{ resendDisabled ? 'Resend OTP in ' + resendTimer + 's' : 'Resend OTP' }}
                </a>
              </div>
            </div>

            <div class="lx-alt-login">
              <a href="javascript:void(0)" (click)="toggleLoginMode()">
                {{ usePasswordLogin ? 'Use OTP Instead' : 'Use Password Instead' }}
              </a>
            </div>

            <!-- Buttons -->
            <div class="lx-btn-row">
              <button type="button"
                class="lx-btn lx-btn-cancel"
                *ngIf="otpSent"
                (click)="cancelOTPLogin()">Cancel</button>
              <button type="submit"
                class="lx-btn lx-btn-primary"
                [disabled]="otpRequestInProgress">
                <span *ngIf="otpRequestInProgress" class="lx-spinner"></span>
                <!-- {{ otpSent ? 'Verify OTP' : 'Send OTP' }} -->
                  {{ usePasswordLogin ? 'Login' : (otpSent ? 'Verify OTP' : 'Send OTP') }}
              </button>
            </div>
                        
            <div *ngIf="usePasswordLogin" class="lx-forgot">
              <a class="lx-forgot-link" (click)="forgotPwd()">Forgot Password?</a>
            </div>

            <!-- Register link -->
            <div class="lx-register-prompt" *ngIf="!otpSent">
              Don't have an account?
              <a routerLink="/registerotp" class="lx-register-link">Register Here</a>
            </div>

          </form>
        </div>

        <!-- Sub-components (multi-login, reset, forgot — untouched) -->
        <app-firmname-login *ngIf="showMultiLogin"
                            [parentData]="firmsData"
                            (event)="onChildEvent($event)"></app-firmname-login>
        <app-resetpwd *ngIf="showResetForm"
                      [parentData]="resetData"
                      (event)="onChildEvent($event)"></app-resetpwd>
        <app-forgotpwd *ngIf='showForgotForm'
                       (event)="onChildEvent($event)"></app-forgotpwd>

        <!-- Mobile-only footer (hidden on tablet/desktop via CSS) -->
        <div class="lx-mobile-footer">Lex-Z Lawyers &copy; 2026. All rights reserved.</div>
      </div>
    </div>
  </div>

  <!-- Terms & Conditions Modal (untouched logic) -->
  <div *ngIf="showTC">
    <div class="modal-backdrop show"></div>
    <div class="modal show" style="padding-right: 15px; display: block;">
      <div class="modal-dialog modal-lg" id="dialog-box">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title pull-left">Terms &amp; Conditions</h5>
            <button type="button" class="close pull-right" aria-label="Close" (click)="closeAgreement()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <iframe width="100%" style="height: 72vh;" src="assets/site/RegsWatchEndCustomerTC.pdf"></iframe>
          </div>
          <div class="modal-footer">
            <p class="text-left">
              By clicking on <strong>"Agree"</strong>, you confirm that you have read and accept the terms and conditions of DigiCoffer, Inc.
            </p>
            <button type="button" class="btn btn-danger modal-close" (click)="closeAgreement()">Close</button>
            <button type="button" class="btn btn-primary" (click)="agree()">Agree</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<!-- =====================================================================
     ALL OTHER PRODUCTS — ORIGINAL DESIGN (untouched)
     ===================================================================== -->
<ng-container *ngIf="product !== 'lauditor'">
  <div class="">
    <div class="row">
      <div class="col-sm-7 loginbglauditor"  *ngIf="product === 'corporate' || product == 'indiamp'"></div>
      <div class="col-sm-7 loginbgcontent" *ngIf="product == 'content'"></div>
      <div class="col-sm-7 loginbgconnect" *ngIf="product == 'connect'"></div>
      <div class="col-sm-5">
        <div class="row">

          <div class="col-sm-12">
            <div class="logomain" *ngIf="product === 'indiamp'">
              <img src="/assets/img/WEBLEXIZLawyerTP2.png" class="loginlogolexiz">
            </div>

            <div class="logomain" *ngIf="product === 'corporate'">
              <img src="/assets/img/WEBLEXIZCorporateTP.png" class="loginlogolexiz">
            </div>

            <div class="logomain" *ngIf="product == 'content'">
              <img src="/assets/site/images/content_logo.jpg" class="loginlogocontent">
            </div>

            <div class="logomainconnect" *ngIf="product == 'connect'">
              <img src="/assets/site/images/cofferconnect-logo.png" class="loginlogoconnect">
              <div class="logotxtconnect">Coffer Connect</div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="loginform" *ngIf="showLoginForm">
               <label id="id_alert" class="logininfo" 
                    [style.color]="msgError ? 'red' : 'green'">
                {{msg}}
               </label>

              <form [formGroup]="otpForm" (ngSubmit)="onOTPSubmit()">
                <div class="signin">Login with OTP</div>
                
              <div class="form-floating mb-3 mt-3" *ngIf="!otpSent">
                <input
                  formControlName="identifier"
                  class="form-control custominput"
                  id="id_otp_identifier"
                  type="text"
                  placeholder="Email or Mobile" />
                <label for="id_otp_identifier" class="lblfocus">Email or Mobile</label>
                <div *ngIf="otpSubmitted && otpF['identifier'].errors" class="text-danger">
                  <div class="errorStyle2" *ngIf="otpF.identifier.errors.required">Email or Mobile is required</div>
                  <div class="errorStyle2" *ngIf="otpF.identifier.errors.invalidIdentifier">Enter a valid email or 10-digit mobile number</div>
                </div>
              </div>

                <div class="otp-input-section" *ngIf="otpSent">
                  <label class="otp-label">Enter OTP</label>
                  <div class="otp-inputs-container">
                    <input #otp1 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 1, otp2)" (paste)="onOtpPaste($event)"
                      [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp2 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 2, otp3)"
                      [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp3 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 3, otp4)"
                      [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp4 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 4, otp5)"
                      [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp5 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 5, otp6)"
                      [(ngModel)]="otpDigits[4]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp6 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 6, null)"
                      [(ngModel)]="otpDigits[5]" [ngModelOptions]="{standalone: true}"/>
                  </div>
                  <div *ngIf="otpSubmitted && otpF['otp'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF['otp'].errors?.required">OTP is required</div>
                    <div class="errorStyle" *ngIf="otpF['otp'].errors?.pattern">OTP must be 6 digits</div>
                  </div>
                  <div class="resend-otp" *ngIf="otpSent">
                    <a href="javascript:void(0);" class="resend-link"
                      [class.disabled]="resendDisabled"
                      (click)="resendOTP()">
                      {{ resendDisabled ? 'Resend OTP in ' + resendTimer + 's' : 'Resend OTP' }}
                    </a>
                  </div>
                </div>

                <div class="btnlogin">
                  <button type="button" class="btn btnlogincancel btncomman"
                    *ngIf="otpSent" (click)="cancelOTPLogin()">Cancel</button>
                  <button type="submit" class="btn btn-primary btnloginsubmit btncomman"
                    [disabled]="otpRequestInProgress">
                    {{ otpSent ? 'Verify OTP' : 'Send OTP' }}
                  </button>
                </div>

                <div class="text-center mt-3" style="margin-top: 15px;">
                  <span style="color: #000000; font-size: 14px;">
                    Don't have an account? 
                    <a routerLink="/registerotp" style="color: #004D87; font-weight: 600; text-decoration: underline; cursor: pointer;">Register Here</a>
                  </span>
                </div>
              </form>
            </div>
            <app-firmname-login *ngIf="showMultiLogin"
                                [parentData]="firmsData"
                                (event)="onChildEvent($event)"></app-firmname-login>
            <app-resetpwd *ngIf="showResetForm"
                          [parentData]="resetData"
                          (event)="onChildEvent($event)"></app-resetpwd>
            <app-forgotpwd *ngIf='showForgotForm'
                           (event)="onChildEvent($event)"></app-forgotpwd>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showTC">
    <div class="modal-backdrop show"></div>
    <div class="modal show" style="padding-right: 15px; display: block;">
      <div class="modal-dialog modal-lg" id="dialog-box">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title pull-left">Terms &amp; Conditions</h5>
            <button type="button" class="close pull-right" aria-label="Close" (click)="closeAgreement()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <iframe width="100%" style="height: 72vh;" src="assets/site/RegsWatchEndCustomerTC.pdf"></iframe>
          </div>
          <div class="modal-footer">
            <p class="text-left">
              By clicking on <strong>"Agree"</strong>, you confirm that you have read and accept the terms and conditions of DigiCoffer, Inc.
            </p>
            <button type="button" class="btn btn-danger modal-close" (click)="closeAgreement()">Close</button>
            <button type="button" class="btn btn-primary" (click)="agree()">Agree</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>